import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EventRoutes from './event';
import GiftcardRoutes from './giftcard';

const PublicRoutes = () => (
  <Routes>
    <Route path="/event/*" element={<EventRoutes />} />
    <Route path="/giftcard/*" element={<GiftcardRoutes />} />
  </Routes>
);

export default PublicRoutes;
